import { useMemo } from 'react';

import { useIsLandscape, useIsLargerThanMedium, useIsUncompessed } from '@pp/core/src/styles/hooks/media';

import { Bets } from '../../config/bets';
import { useHighflyerGameStateSlice } from '../../store/slices/highflyerGame/selectors';
import {
  useIsLargerThanWidth900AndHeight567,
  useIsSmallerThanExtraExtraNarrow,
  useIsSmallerThanHeight335AndLandscape,
} from '../../styles/hooks/media';
import { BUTTON_STATES } from '../GameBetButton/types';
import { useButtonStatusConnected } from '../gameGrid/hooks';

export const useShowCollapsedMode = (betCode: Bets): boolean => {
  const isLargerThanMedium = useIsLargerThanMedium();
  const isLandscape = useIsLandscape();
  const isUnCompressed = useIsUncompessed();
  const isLargerThanWidth900AndHeight567 = useIsLargerThanWidth900AndHeight567();
  const isSecondBetBoardEnabled = useHighflyerGameStateSlice.getIsSecondBetBoardToggle();
  const isSmallerThanExtraExtraNarrow = useIsSmallerThanExtraExtraNarrow();
  const isSmallerThan335AndLandscape = useIsSmallerThanHeight335AndLandscape();
  const { state: Button_State } = useButtonStatusConnected(betCode);

  return useMemo(() => {
    return (
      Button_State !== BUTTON_STATES.confirm &&
      ((isLandscape &&
        !isSmallerThan335AndLandscape &&
        isLargerThanMedium &&
        isUnCompressed &&
        !isLargerThanWidth900AndHeight567 &&
        isSecondBetBoardEnabled) ||
        isSmallerThanExtraExtraNarrow)
    );
  }, [
    Button_State,
    isLargerThanMedium,
    isLandscape,
    isUnCompressed,
    isLargerThanWidth900AndHeight567,
    isSecondBetBoardEnabled,
    isSmallerThanExtraExtraNarrow,
    isSmallerThan335AndLandscape,
  ]);
};
